
document.addEventListener('alpine:init', () => {
  const defaults = {
    pet: "puppy",
    age: 8,
    ageUnit: "weeks",
    weight: 0,
    activityLevel: "moderate",
    showOutput: false,
    output: "",
  };
  Alpine.store("feedingCalculator", {
    ...defaults,
    init() {
      this.$watch && this.$watch("pet", () => this.onUpdatePet());

      this.$watch && this.$watch("pet", () => this.calculate());
      this.$watch && this.$watch("age", () => this.calculate());
      this.$watch && this.$watch("ageUnit", () => this.calculate());
      this.$watch && this.$watch("weight", () => this.calculate());
      this.$watch && this.$watch("activityLevel", () => this.calculate());
    },
    isPetAdult() { 
      return this.pet === 'dog' || this.pet === 'cat';
    },
    onUpdatePet() {
      if (this.isPetAdult()) {
        this.age = 2;
        this.ageUnit = "years";
      } else {
        this.age = 8;
        this.ageUnit = "weeks";
      }

      this.weight = 0;
      this.activityLevel = "moderate";
    },    
    calculate() {
      const weightMultiplier = this.getWeightMultiplier();
      let output = (this.weight * weightMultiplier).toFixed(2);
      let unit = "g";
      // Prevent negative value
      output = Math.max(output, 0);

      // Convert output to grams if less than 1kg
      if (output < 1) { 
        output = output * 1000;
        unit = "g";
      } else {
        unit = "kg";
      }

      if (output > 0) {
        this.output = `${output}${unit} per day`;  
      } else {
        this.output = "";
      }

      if (this.age > 0 && this.weight > 0) {
        this.showOutput = true;
      }
    },
    getWeightMultiplier() {
      let base = 0;
      if (this.isPetAdult()) {
        base = 0.03;
      } else {
        if (this.age >= 8 && this.age <= 10) base = 0.1;
        if (this.age >= 11 && this.age <= 16) base = 0.08;
        if (this.age >= 17 && this.age <= 20) base = 0.07;
        if (this.age >= 21 && this.age <= 24) base = 0.06;
        if (this.age >= 25 && this.age <= 36) base = 0.05;
        if (this.age >= 37 && this.age <= 56) base = 0.04;
        if (this.age >= 57 && this.age <= 68) base = 0.03;
      }

      const adultActivityModifierMatrix = {
        low: -0.01,
        moderate: 0,
        high: 0.01,
        athletic: 0.02,
      };

      return base + adultActivityModifierMatrix[this.activityLevel];
    },
    reset() {
      for (const key in defaults) {
        this[key] = defaults[key];
      }      
    }
  });
});